import { Component } from 'vue-property-decorator'
import { MemberActivities } from '@src/routes/members/member-activities'
import { MemberActivityFilters } from '@src/state/store'
import { CreateElement } from 'vue'
import { ErrorScreen } from '@src/components/error-screen/error-screen'
import { Body1, Subtitle1 } from '@src/elements/typography/typography'
import { Spacer } from '@src/elements/spacer/spacer'
import QrcodeVue from 'qrcode.vue'

@Component({
  computed: {
    activityFilters () {
      return this.$store.state.member_activities.memberActivityFilters
    }
  }
})
export class ReadonlyActivities extends MemberActivities {

  protected PAGE_SIZE = Math.floor((window.innerHeight - 140) / 105)

  protected activityFilters: MemberActivityFilters

  setDocumentTitle () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('PAGE.MEMBERS.DETAIL.TABS.ACTIVITIES')}`
  }

  renderErrorScreen (h: CreateElement) {
    return <ErrorScreen icon='brand/no-phone' class='activities-error'>
      <Body1>
        <div domPropsInnerHTML={this.$t('PAGE.MEMBERS.ACTIVITIES.NO_ACTIVITIES', { mobilePixAppName: `<b>${this.$t('MOBILE_APP_NAME')}</b>` })} />
      </Body1>
      <Spacer />
      <QrcodeVue value={`${window.location.host}/app`} size={250} class='generated-qr-code' />
      <Subtitle1>{this.$t('PAGE.MEMBERS.ACTIVITIES.DOWNLOAD_NOW')}</Subtitle1>
      <Spacer />
      <Body1>{this.$t('PAGE.MEMBERS.ACTIVITIES.SITE_LINK')}</Body1>
      <Body1><a href='mailto:feedback@pixformance.com' target='_blank'>feedback@pixformance.com</a></Body1>
    </ErrorScreen>
  }
}
